import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  SimpleGrid,
  Box,
  Input,
  FormLabel,Select,
  InputGroup,
  InputLeftAddon,useDisclosure,
  Checkbox,
  

} from '@chakra-ui/react';
import { useState,useEffect } from 'react';
import { IoMdClose } from "react-icons/io";
import axios from 'axios'
import toast from 'react-hot-toast';
import { set } from 'lodash';
import Cookie from 'js-cookie';

const ServerTipModal = ({isOpen,onClose,id,customerId,onOpen,setSelectId,data}) => {
    
    console.log(id,'id')    
    const token=Cookie.get('token')
    const [selectedFile, setSelectedFile] = useState(null);
    const [serverName,setServerName]=useState([])
    const[newImageURL,setnewImageURL]=useState(null);
    const [uploading, setUploading] = useState(false);
    const [formData,setFormData]=useState({
        foodItem: [],
        wineItem: [],
        
       
        name: "",
        phoneNo:"",
        billNo: "",
        tableNo: "",
        server:"",
        totalBilling:0,
        discount:0,
        discountPercentage:0,
        cash:0,
        mode:"",
        online:0,
        createdAt:"",
        serverTip:null
        
  
  
       
  
        
       
    
    
    })
    
    
    

   
   
   console.log(Object.keys(data)+" :"+Object.values(data),'data')
   const serverData=async()=>{
    try {
      const response = await axios.get(`https://api.rcb.tdrsoftware.in/api/waiterList/${customerId}`);
      setServerName(response.data.waiterList);
      
    } catch (error) {
      
    }
   }
   const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toISOString().split('T')[0]; // Extracts the YYYY-MM-DD part
  };
   
  useEffect(()=>{
  serverData()
  },[customerId])
    useEffect(() => {
        if (data) {
          //const date = new Date(data.createdAt).toLocaleString();
            setFormData({
               foodItem: data.foodItem || [],
               wineItem: data.wineItem || [],
               name: data.name || "",
               phoneNo:data.phoneNo || "",
               billNo: data.billNo || "",
               tableNo: data.tableNo ||"",
                server:data.server || "",
        totalBilling:data.totalBilling || 0,
        discount:data.discount || 0,
        discountPercentage:data.discountPercentage || 0,
        cash:data.cash || 0,
        mode:data.mode || "",
        online:data.online || 0,
        due:data.due || 0,
        createdAt:data.createdAt ? formatDate(data.createdAt): "",
        cgst:data.cgst,
        sgst:data.sgst,
        serverTip:data.serverTip
                
            });
        }
    }, [data]);
    const scroll='inside'
   
    const handleInputChange=(e)=>{
     const {name,value}=e.target;
     setFormData({
        ...formData,
       [name] : value 
     })
    }
    
//   useEffect(() => {
    
//   const totalPaid = 
//     (formData.cash ? parseInt(formData.cash) : 0) + 
//     (formData.online ? parseInt(formData.online) : 0) + 
//     (formData.discount ? parseInt(formData.discount) : 0) + 
//     ((formData.discountPercentage / 100) * totalBilling);

//   const newDue = Math.max(totalBilling - totalPaid, 0); // Prevent negative due
//   setFormData((prev) => ({
//     ...prev,
//     due: newDue,
//   }));
// }, [formData.cash, formData.online, formData.discount, formData.discountPercentage, totalBilling]);

    
   
  
  
   
    const handleEdit = async (e) => {
      e.preventDefault();
     let totalPayment=parseInt(formData.cash)+parseInt(formData.online)+parseInt(formData.discount);
       
        
          
        try {
            // Make the PUT request with formData directly
            const response = await axios.put(`https://api.rcb.tdrsoftware.in/api/serverNameUpdate/${customerId}/${id}?customerId=${customerId}`,{data:formData},{
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });
            
            toast.success(response.data.message);
            console.log(response, 'response');
            //setSelectId(null);
            // Optionally reset the form after a successful update
            setFormData({
                foodItem: [],
                wineItem: [],
                
               
                name: "",
                phoneNo:"",
                billNo: "",
                tableNo: "",
                server:"",
                totalBilling:0,
                discount:0,
                discountPercentage:0,
                cash:0,
                mode:"",
                online:0,
                due:0,
                createdAt: "",
                serverTip:null
            });
           window.location.reload();
    
        } catch (error) {
           if(error.response && error.response.status === 403) {
            toast.error(error.response.data.message);
          } else {
            toast.error('An error occurred while updating the data');
          }
        }
    };
    const handleClick=()=>{
      onClose()
      setSelectId(null);
    }
  return (
    <Modal  width='full' size='3xl' isOpen={isOpen} onClose={onClose} onOpen={onOpen} scrollBehavior={scroll}  >
      <ModalOverlay />
      <ModalContent bg='#f9f1e3'>
        <ModalHeader display='flex' justifyContent='space-between' alignItems='center'>
            <Text>Bill Data- {data?.name}</Text>
            <Button colorScheme='red' onClick={handleClick} ><IoMdClose/></Button></ModalHeader>
       
        <ModalBody >
       
       
         <SimpleGrid columns={2} gap={4} placeItems='left'>
           
           <InputGroup>
            <InputLeftAddon>Server</InputLeftAddon>
           <Select  bg='white' onChange={handleInputChange} name='server' placeholder='Enter Server' value={formData.server} >
            {serverName?.map((item,index)=>(
              <option key={index} value={item.name}>{item.name}</option>
            ))}
           </Select>
           </InputGroup>
            <InputGroup>
            <InputLeftAddon>Server Tip</InputLeftAddon>
           <Input  bg='white' onChange={handleInputChange} name='serverTip' placeholder='Enter Server Tip' value={formData.serverTip} />
            
           </InputGroup>
           
          
          
           

         </SimpleGrid>
         <Box display='flex' alignItems='center' justifyContent='center' gap={4} mt={2}>
       
         <Button colorScheme='green' onClick={(e)=>handleEdit(e)} >Add Tip</Button>
         </Box>
        </ModalBody>

        <ModalFooter>
         
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ServerTipModal;
